export default "__VITE_ASSET__566a6a28__"